"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCardiovascularDiseases = createCardiovascularDiseases;
const cardiovascularDiseases_1 = require("../../../forms/ktx/transplantation-screening/medical-history/cardiovascularDiseases");
const shared_1 = require("../../shared");
const queries_1 = require("../queries");
const events_1 = require("../../../events");
const utils_1 = require("../../../events/utils");
const messages = {
    title: {
        id: "ktx.dashboard.cardiovascular_diseases",
        defaultMessage: "Kardiovaszkuláris betegségek"
    }
};
const allMessages = {
    ...cardiovascularDiseases_1.cardiovascularDiseaseTypeMessages,
    ...cardiovascularDiseases_1.coronaryDiseaseTypeMessages,
    ...cardiovascularDiseases_1.hasDiseaseMessages
};
function createCardiovascularDiseases(intl, { events }) {
    const { formatMessageMap, formatDate } = intl;
    const relevantEvents = (0, utils_1.findEventsByQuery)(events, queries_1.medicalHistoryQueries.cardiovascularDiseases);
    const list = relevantEvents
        .map(event => {
        const { timestamp, origin } = event;
        const formattedTimestamp = formatDate(timestamp, {
            year: "numeric",
            month: "numeric",
            day: "numeric"
        });
        const items = [];
        items.push({
            type: "list-item",
            value: formatMessageMap(allMessages, event.value)
        });
        return {
            type: "list",
            attachments: (0, events_1.mapEventsToAttachments)(event),
            timestamp: event.timestamp,
            label: formattedTimestamp,
            origin,
            items
        };
    })
        .sort(shared_1.compareByTimestamp);
    const content = (0, shared_1.createGroupContent)(list);
    return (0, shared_1.createGroup)(intl, { label: messages.title, content });
}
